import React from 'react'

import { ResumePreviewFontSizeLegend } from './ResumePreviewFontSizeLabelsContent'
import { ResumePreviewLineGuidesLegend } from './ResumePreviewLineGuidesOverlay'

type ResumePreviewDebugLegendProps = {
  lineGuides?: boolean
  fontSizeDebug?: boolean
}

/** One block above the sheets when either or both debug URL params are active. */
export default function ResumePreviewDebugLegend({
  lineGuides = false,
  fontSizeDebug = false,
}: ResumePreviewDebugLegendProps) {
  if (!lineGuides && !fontSizeDebug) return null

  const urlHint =
    lineGuides && fontSizeDebug
      ? '?lineGuides=1&fontSizes=1'
      : lineGuides
        ? '?lineGuides=1'
        : '?fontSizes=1'

  return (
    <div className="resume-preview-debug-legend mb-3 flex w-full max-w-[210mm] flex-col gap-2">
      <p className="rounded-md border border-border-default bg-surface-elevated px-3 py-1.5 text-[11px] text-text-secondary shadow-sm">
        Режим отладки превью:{' '}
        <span className="font-mono text-text-primary">{urlHint}</span>
        {lineGuides && fontSizeDebug ? ' — полоски и кегль одновременно' : null}
      </p>
      {lineGuides && <ResumePreviewLineGuidesLegend />}
      {fontSizeDebug && <ResumePreviewFontSizeLegend />}
    </div>
  )
}
